<app-header-style-two></app-header-style-two>

<div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="index.html">Home</a></li>
                <li><a href="courses-2-columns-style-1.html">Courses</a></li>
                <li>Certified Graphic Design with Free Project Course</li>
            </ul>
            <h2>Courses</h2>
        </div>
    </div>
</div>

<div class="courses-details-area pt-100 pb-70">
    <div class="container">
        <div class="courses-details-header">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <div class="courses-title">
                        <h2>Ambulanta</h2>
                    </div>
                </div>

            </div>
        </div>
        <div class="row">
            <div class="col-lg-8">
                <div class="courses-details-desc">
                    <div class="courses-review-comments">
                        <h3>Medici</h3>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="user-review">
                                <img src="assets/img/medici/no-image.jpg" alt="image">
    
                                <span class="d-block sub-comment">Dr. Bruma Gabriel Olimpiu</span>
                                <p>Medic specialist ambulanta</p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="user-review">
                                <img src="assets/img/medici/no-image.jpg" alt="image">
    
                                <span class="d-block sub-comment">Dr. Butz Laviniu</span>
                                <p>Medic specialist ambulanta</p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="user-review">
                                <img src="assets/img/medici/no-image.jpg" alt="image">
    
                                <span class="d-block sub-comment">Dr. Cazacu Constantin Marius</span>
                                <p>medic primar ambulanta</p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="user-review">
                                <img src="assets/img/medici/no-image.jpg" alt="image">
    
                                <span class="d-block sub-comment">Dr. Docsanescu Dan-Andrei</span>
                                <p>medic specialist ambulanta</p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="user-review">
                                <img src="assets/img/medici/no-image.jpg" alt="image">
    
                                <span class="d-block sub-comment">Dr. Socoliuc Dumitru-Alexandru</span>
                                <p>medic specialist ambulanta</p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="user-review">
                                <img src="assets/img/medici/no-image.jpg" alt="image">
    
                                <span class="d-block sub-comment">Dr. Stanciu Liviu Lucian</span>
                                <p>medic specialist ambulanta</p>
                            </div>
                        </div>                                                
                    </div>
                </div>
            </div>
    
            </div>
            <div class="col-lg-4">
                <app-sidebar-specialites></app-sidebar-specialites>

            </div>
        </div>
    </div>
</div>
